// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"bf_c0","animated":"bf_c1","anchorToSection11X":"bf_c2","anchorToSection":"bf_cq","anchorToSection6X":"bf_c3","anchorToSection4X":"bf_c4"};